import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

export const SectionTitle = ({ icon: Icon, title, color = "text-[var(--accent-color)]" }) => (
    <div className={`flex items-center gap-3 ${color} mb-6`}>
        <Icon size={20} />
        <span className="text-[11px] font-black uppercase tracking-[0.3em] italic leading-none">{title}</span>
    </div>
);

export const InfoField = ({ label, value, color = "text-[var(--text-primary)]", bold = false, font = "text-sm", lowercase = false }) => (
    <div className="flex flex-col min-w-0">
        <span className="text-[9px] font-black uppercase text-[var(--text-secondary)] opacity-50 tracking-widest mb-1">{label}</span>
        <span className={`${font} ${bold ? 'font-black' : 'font-medium'} ${color} ${lowercase ? 'lowercase' : 'uppercase'} truncate leading-tight`}>
            {value || '---'}
        </span>
    </div>
);

export const MissingDataSlot = ({ label }) => (
    <div className="flex flex-col items-center justify-center p-8 border-2 border-dashed border-amber-500/30 rounded-[2.5rem] bg-amber-500/5 text-amber-600 text-center">
        <FiAlertCircle size={28} className="animate-bounce mb-2" />
        <span className="text-[10px] font-black uppercase tracking-widest leading-relaxed">{label}</span>
    </div>
);